import { core_apimessages_ShippingLabelPackage } from '../../../schemas/rql';
import { get } from 'lodash';
import { isUSA } from '../../../lib/geo';

export enum MeasurementSystem {
  METRIC = 'metric',
  IMPERIAL = 'imperial',
}

export enum PackageType {
  CUSTOM = 'custom',
  FLAT_RATE = 'flatRate',
}

export function mapCountryCodeToDefaultMeasurementSystem(
  countryCode: string,
): MeasurementSystem {
  if (isUSA(countryCode)) {
    return MeasurementSystem.IMPERIAL;
  }

  return MeasurementSystem.METRIC;
}

export function buildNewPackage(
  measurementSystem: MeasurementSystem,
): core_apimessages_ShippingLabelPackage {
  return buildPackage({}, measurementSystem);
}

export function convertPackageUnits(
  shippingLabelPackage: core_apimessages_ShippingLabelPackage,
  measurementSystem: MeasurementSystem,
): core_apimessages_ShippingLabelPackage {
  return buildPackage(shippingLabelPackage, measurementSystem);
}

export function getMeasurementUnitFromPackage(
  shippingPackage: core_apimessages_ShippingLabelPackage,
): MeasurementSystem {
  if (shippingPackage.length.unit === LengthUnit.INCHES) {
    return MeasurementSystem.IMPERIAL;
  }
  return MeasurementSystem.METRIC;
}

export function buildPackage(shippingLabelPackage, measurementSystem: MeasurementSystem) {
  const lengthUnit = getLengthUnit(measurementSystem);
  const weightUnit = getWeightUnit(measurementSystem);

  const lengthValue = get(shippingLabelPackage, 'length.value') || '';
  const widthValue = get(shippingLabelPackage, 'width.value') || '';
  const heightValue = get(shippingLabelPackage, 'height.value') || '';
  const weightValue = get(shippingLabelPackage, 'weight.value') || '';

  const predefinedPackage = get(shippingLabelPackage, 'predefinedPackage') || '';

  return (
    {
      predefinedPackage,
      length: {
        value: lengthValue,
        unit: lengthUnit,
      },
      width: {
        value: widthValue,
        unit: lengthUnit,
      },
      height: {
        value: heightValue,
        unit: lengthUnit,
      },
      weight: {
        value: weightValue,
        unit: weightUnit,
      },
    }
  );
}

export enum LengthUnit {
  CENTIMETERS = 'cm',
  INCHES = 'in',
}

export enum WeightUnit {
  KILOGRAMS = 'kg',
  POUNDS = 'lb',
}

function getLengthUnit(measurementSystem: MeasurementSystem) {
  if (measurementSystem === MeasurementSystem.METRIC) {
    return LengthUnit.CENTIMETERS;
  }

  return LengthUnit.INCHES;
}

function getWeightUnit(measurementSystem: MeasurementSystem) {
  if (measurementSystem === MeasurementSystem.METRIC) {
    return WeightUnit.KILOGRAMS;
  }

  return WeightUnit.POUNDS;
}
